module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu2.5b9e5f8a.jpg";